export class LeadSnippetModel {
    branchName: string;
    consumerId: string;
    consumerLeadId: string;
    createdAt: string;
    createdBy: string;
    email: string;
    firstName: string;
    lastName: string;
    mobile: string;
    partnerId: string;
    partnerName: string;
    status: string;
    transactionMode: string;
    assignedTo: string;
    comment: string;
}


// WEBPACK FOOTER //
// ./src/app/_models/lead/LeadSnippetModel.ts